<div class="container-fluid">

  <form #rptForm="ngForm">

    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h3>ARS Inspection Report - {{ inspectionReport?.reportName || 'New'}}</h3>
      </div>
      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">

          <aims-common-button *ngIf="rptForm.form.dirty"
            title="Cancel"
            aria-label="Cancel"
            [disabled]="saveClicked || !rptForm.form.dirty || !calculateEditable()"
            (click)="cancelRptUpdate()">
            <mat-icon color="primary">cancel</mat-icon>
            Cancel
          </aims-common-button>

          <aims-common-button *ngIf="rptForm.form.dirty"
            title="Save"
            aria-label="Save"
            [disabled]="(saveClicked || !rptForm.valid || !rptForm.form.dirty || !calculateEditable())"
            (click)="saveInspectionReport()">
            <mat-icon color="primary">save</mat-icon>
            Save
          </aims-common-button>

          <aims-common-button *ngIf="calculateEditable()"
            title="QC Approve"
            aria-label="QC Approve"
            [disabled]="(!rptForm.valid || rptForm.form.dirty)"
            (click)="qcFinalApproval()">
            <mat-icon color="primary">thumb_up</mat-icon>
            QC Approve
          </aims-common-button>

          <aims-common-button *ngIf="permissions.canRead(this.permissions.ComponentID.InspectionReports)"
            title="Print"
            aria-label="Print"
            [disabled]="(!rptForm.valid || rptForm.form.dirty)"
            (click)="print()">
            <mat-icon color="primary">print</mat-icon>
            Print
          </aims-common-button>
        </div>
      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />

    <ng-container *ngIf="inspectionReport !== undefined">
      <aims-form cols="4">
        <aims-fc [showDescendants]="false">
          <aims-form cols="1" [editable]="calculateEditable()">
            <aims-fc>

              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="Contract Number"
                  [(ngModel)]="inspectionReport.contractNumberId"
                  required>
                    <mat-option *ngFor="let c of contractNumberValues | async" [value]="c.contractNumberId">
                        {{ c.contractNumber }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>

            <aims-fc>
              <mat-form-field appearance="fill">
                <input matInput #aimsControl="ngModel" class="fullWidth" name="Report Name" type="text"
                  [(ngModel)]="inspectionReport.reportName" required />
              </mat-form-field>
            </aims-fc>

            <aims-fc >
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="Site"
                  [(ngModel)]="inspectionReport.siteId"
                  required>
                    <mat-option *ngFor="let s of siteValues | async" [value]="s.siteId">
                        {{ s.siteName }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>
            <aims-fc >
              <mat-form-field>
                <mat-label></mat-label>
                <input name="Date of Inspection" matInput #aimsControl="ngModel" [matDatepicker]="picker1"
                              [(ngModel)]="inspectionReport.inspectionDate" placeholder="mm/dd/yyyy"
                              required [max]="today">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 ></mat-datepicker>
              </mat-form-field>
            </aims-fc>
            <ng-container *ngIf="inspectionReport.inspectionReportId > 0">
              <aims-fc [showDescendants]="false">
                <aims-file-upload #aimsControl="ngModel"
                    [(ngModel)]="inspectionReport.attachmentName"
                    name="Report Title Image"
                    [allowedFileType]="'.jpg,.png,.pdf'"
                    [maxFileSize]="4194304"
                    [saveUrl]="'QualityControl/SaveInspectionReportAttachment?inspectionReportId='+inspectionReport.inspectionReportId"
                    [removeUrl]="'QualityControl/DeleteInspectionReportAttachment?inspectionReportId='+inspectionReport.inspectionReportId"
                    [downloadUrl]="'QualityControl/DisplayInspectionReportAttachment?inspectionReportId='+inspectionReport.inspectionReportId"
                    (success)="loadInspectionReport(inspectionReport.inspectionReportId)"
                    (fileDeleted)="uploadRemoved()"
                ></aims-file-upload>
              </aims-fc>
            </ng-container>
          </aims-form>
        </aims-fc>

        <aims-fc [showDescendants]="false">
          <aims-form cols="1" [editable]="calculateEditable()">
            <aims-fc >
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="1st Reference"
                  [(ngModel)]="inspectionReport.ref1Id"
                  required>
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>

            <aims-fc >
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="2nd Reference"
                  [(ngModel)]="inspectionReport.ref2Id" >
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>

            <aims-fc>
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="3rd Reference"
                  [(ngModel)]="inspectionReport.ref3Id" >
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>
            <aims-fc>
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="4th Reference"
                  [(ngModel)]="inspectionReport.ref4Id" >
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>

            <aims-fc>
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="5th Reference"
                  [(ngModel)]="inspectionReport.ref5Id" >
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>
            <aims-fc>
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="6th Reference"
                  [(ngModel)]="inspectionReport.ref6Id" >
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>
            <aims-fc >
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="7th Reference"
                  [(ngModel)]="inspectionReport.ref7Id" >
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>
            <aims-fc>
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="8th Reference"
                  [(ngModel)]="inspectionReport.ref8Id" >
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>
            <aims-fc>
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="9th Reference"
                  [(ngModel)]="inspectionReport.ref9Id" >
                    <mat-option *ngFor="let i of inspectionReferenceValues | async" [value]="i.inspectionReferenceId">
                        {{ i.inspectionReference }}
                    </mat-option>
                </mat-select>
              </mat-form-field>

            </aims-fc>
          </aims-form>
        </aims-fc>

        <aims-fc [showDescendants]="false">
          <aims-form cols="1" [editable]="calculateEditable()">
            <aims-fc [showDescendants]="false">
              <aims-lookup
                #aimsControl="ngModel"
                class="fullWidth"
                name="1st Site Personnel"
                id="sitePersonnel1Id"
                [gridText]="'Select an Employee to assign as the 1st Site Personnel'"
                [values]="employeeValues | async"
                [idPropertyName]="'employeeId'"
                [displayPropertyName]="'fullName'"
                [(ngModel)]="inspectionReport.sitePersonnel1Id"
                [columnsInGrid]="employeeLookupColumns">
              </aims-lookup>

              <mat-checkbox name="Chief1" title="Station Chief?" style="margin-top: 5px;"
                [(ngModel)]="inspectionReport.isStaChief1" tabindex="-1" >
              </mat-checkbox>
            </aims-fc>
            <aims-fc [showDescendants]="false">
              <aims-lookup
                #aimsControl="ngModel"
                class="fullWidth"
                name="2nd Site Personnel"
                id="sitePersonnel2Id"
                [gridText]="'Select an Employee to assign as the 2nd Site Personnel'"
                [values]="employeeValues | async"
                [idPropertyName]="'employeeId'"
                [displayPropertyName]="'fullName'"
                [(ngModel)]="inspectionReport.sitePersonnel2Id"
                [columnsInGrid]="employeeLookupColumns">
              </aims-lookup>
              <mat-checkbox name="Chief2" title="Station Chief?" style="margin-top: 5px;"
                [(ngModel)]="inspectionReport.isStaChief2" tabindex="-1" >
              </mat-checkbox>
            </aims-fc>
            <aims-fc [showDescendants]="false">
              <aims-lookup
                #aimsControl="ngModel"
                class="fullWidth"
                name="3rd Site Personnel"
                id="sitePersonnel3Id"
                [gridText]="'Select an Employee to assign as the 3rd Site Personnel'"
                [values]="employeeValues | async"
                [idPropertyName]="'employeeId'"
                [displayPropertyName]="'fullName'"
                [(ngModel)]="inspectionReport.sitePersonnel3Id"
                [columnsInGrid]="employeeLookupColumns">
              </aims-lookup>
              <mat-checkbox name="Chief3" title="Station Chief?" style="margin-top: 5px;"
                [(ngModel)]="inspectionReport.isStaChief3" tabindex="-1" >
              </mat-checkbox>
            </aims-fc>
            <aims-fc [showDescendants]="false">
              <aims-lookup
                #aimsControl="ngModel"
                class="fullWidth"
                name="4th Site Personnel"
                [gridText]="'Select an Employee to assign as the 4th Site Personnel'"
                id="sitePersonnel4Id"
                [values]="employeeValues | async"
                [idPropertyName]="'employeeId'"
                [displayPropertyName]="'fullName'"
                [(ngModel)]="inspectionReport.sitePersonnel4Id"
                [columnsInGrid]="employeeLookupColumns">
              </aims-lookup>
              <mat-checkbox name="Chief4" title="Station Chief?" style="margin-top: 5px;"
                [(ngModel)]="inspectionReport.isStaChief4" tabindex="-1" >
              </mat-checkbox>
            </aims-fc>
          </aims-form>
        </aims-fc>

        <aims-fc [showDescendants]="false">
          <aims-form cols="1" [editable]="calculateEditable()">
            <aims-fc [labelColSize]="4" [controlColSize]="8">
              <aims-lookup
                #aimsControl="ngModel"
                class="fullWidth"
                name="1st Inspector"
                id="inspector1Id"
                [gridText]="'Select an Employee to assign as the 1st Inspector'"
                [values]="employeeValues | async"
                [idPropertyName]="'employeeId'"
                [displayPropertyName]="'fullName'"
                [(ngModel)]="inspectionReport.inspector1Id"
                [columnsInGrid]="employeeLookupColumns"
                required>
              </aims-lookup>
            </aims-fc>
            <aims-fc [labelColSize]="4" [controlColSize]="8">
              <aims-lookup
                #aimsControl="ngModel"
                class="fullWidth"
                name="2nd Inspector"
                id="inspector2Id"
                [gridText]="'Select an Employee to assign as the 2nd Inspector'"
                [values]="employeeValues | async"
                [idPropertyName]="'employeeId'"
                [displayPropertyName]="'fullName'"
                [(ngModel)]="inspectionReport.inspector2Id"
                [columnsInGrid]="employeeLookupColumns">
              </aims-lookup>
            </aims-fc>
            <aims-fc [labelColSize]="4" [controlColSize]="8">
              <aims-lookup
                #aimsControl="ngModel"
                class="fullWidth"
                name="3rd Inspector"
                id="inspector3Id"
                [gridText]="'Select an Employee to assign as the 3rd Inspector'"
                [values]="employeeValues | async"
                [idPropertyName]="'employeeId'"
                [displayPropertyName]="'fullName'"
                [(ngModel)]="inspectionReport.inspector3Id"
                [columnsInGrid]="employeeLookupColumns">
              </aims-lookup>
            </aims-fc>
            <aims-fc [labelColSize]="4" [controlColSize]="8">
              <aims-lookup
                #aimsControl="ngModel"
                class="fullWidth"
                name="4th Inspector"
                id="inspector4Id"
                [gridText]="'Select an Employee to assign as the 4th Inspector'"
                [values]="employeeValues | async"
                [idPropertyName]="'employeeId'"
                [displayPropertyName]="'fullName'"
                [(ngModel)]="inspectionReport.inspector4Id"
                [columnsInGrid]="employeeLookupColumns">
              </aims-lookup>
            </aims-fc>
          </aims-form>
        </aims-fc>

      </aims-form>
      <br />
      <aims-form [spaceRows]="false" [cols]="1" [header]="'Link Items'" [hider]="true">
        <aims-fc [labelColSize]="12" [controlColSize]="12" [showDescendants]="false">
          <mat-tab-group>
            <mat-tab label="Observation(s)">
              <aims-common-table
                id="observations-table"
                [dataSource]="inspectionReport.qcObservations"
                [defaultTableState] = "{ sort:{ active : 'obsInspNum', direction: 'asc' }}"
                [header]="observationsTableHeader"
                [permissions]="observationsTablePermissions"
                [pageSize]="10"
                [stickyHeader]="true">

                <aims-common-table-dynamic-row id="observationTypeId">
                  <ng-template viewMode let-element >
                    {{ element.observationTypeId | getText:'observationTypeId':'observationType':obsTypeValues | async }}
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter" name="observationFilter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let o of obsTypeValues | async" [value]="o.observationTypeId">
                          {{ o.observationType}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="deficiencyTypeId">
                  <ng-template viewMode let-element >
                    {{ element.deficiencyTypeId | getText:'deficiencyTypeId':'deficiencyType':defTypeValues | async }}
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter" name="deficiencyFilter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let d of defTypeValues | async" [value]="d.deficiencyTypeId">
                          {{ d.deficiencyType}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="nonConformance">
                  <ng-template viewMode let-element >
                    {{ element.nonConformance.substring(0,300) + "..."}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="areaId">
                  <ng-template viewMode let-element >
                      {{ element.areaId | getText:'areaId':'area':areaValues | async }}
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter" name="areaFilter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let a of areaValues | async" [value]="a.areaId">
                          {{ a.area }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>

              </aims-common-table>
            </mat-tab>

            <mat-tab label="Work Order(s)">
              <aims-common-table
                id="wo-table"
                [dataSource]="workorders"
                [defaultTableState] = "{ sort:{ active : 'workOrderNumber', direction: 'asc' }}"
                [header]="woTableHeader"
                [permissions]="woTablePermissions"
                [pageSize]="10"
                [stickyHeader]="true">
              </aims-common-table>
            </mat-tab>

            <mat-tab label="JCN(s)">
              <aims-common-table
                id="jcn-table"
                [dataSource]="jcns"
                [defaultTableState] = "{ sort:{ active : 'jobControlNumber', direction: 'asc' }}"
                [header]="jcnTableHeader"
                [permissions]="jcnTablePermissions"
                [pageSize]="10"
                [stickyHeader]="true">

                <aims-common-table-dynamic-row id="observationId">
                  <ng-template viewMode let-element >
                      <a style="text-decoration:underline;cursor:pointer"
                        [routerLink]="'/projectSupport/observation/' + dataItem.observationId"
                        target="_blank">{{ dataItem.observationId | getText:'observationId':'obsInspNum':inspectionReport.qcObservations }}</a>
                  </ng-template>
                </aims-common-table-dynamic-row>

              </aims-common-table>
            </mat-tab>
          </mat-tab-group>
        </aims-fc>
      </aims-form>
      <br />
      <aims-form cols="1" [editable]="calculateEditable()" [spaceRows]="true">
        <aims-fc [labelColSize]="12" [controlColSize]="12" >
          <mat-form-field appearance="fill">
            <textarea matInput #aimsControl="ngModel" name="General Inspection Comments" [autoSize]="true"
              [(ngModel)]="inspectionReport.generalComments" required>
            </textarea>
          </mat-form-field>
        </aims-fc>

        <aims-fc [labelColSize]="12" [controlColSize]="12" >
          <mat-form-field appearance="fill">
            <textarea matInput #aimsControl="ngModel" name="Overall Impression of the Facilities" [autoSize]="true"
              [(ngModel)]="inspectionReport.overallImpressionOfFacilities" required>
            </textarea>
          </mat-form-field>
        </aims-fc>

      </aims-form>
    </ng-container>
  </form>
  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="rptNotLoaded()"></aims-spinner>

</div>
